export default __webpack_public_path__ + "static/media/white-bishop.0d51db70.png";